import axios from 'axios';
import {
  BASE_URL,
  DATE_FILTER,
  PAGINATION,
  RESTAURANT_ID_FILTER,
  SEARCH,
  STATUS_FILTER,
  TRANSACTIONS_URL,
  USER_ID_FILTER,
} from './Urls';
import {IParamsInfo} from './index.d';

export class TransactionApiModule {
  constructor() {}

  async getAllTransactions(paramInfo: IParamsInfo) {
    try {
      const response = await axios.get(
        BASE_URL +
          PAGINATION(TRANSACTIONS_URL, paramInfo.pageNo, paramInfo?.pageSize) +
          SEARCH(paramInfo?.searchKeyword) +
          USER_ID_FILTER(paramInfo?.userIdFilter) +
          RESTAURANT_ID_FILTER(paramInfo?.restaurantIdFilter) +
          STATUS_FILTER(paramInfo?.statusFilter) +
          DATE_FILTER(paramInfo.startDate, paramInfo.endDate)
      );
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data || [],
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: [],
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: [],
        message: error.response.data.message || error.message,
      };
    }
  }
}
